import React, { FC } from 'react'
import { ShapeElement } from '../../templateEditor.types'
import { EditorTheme } from '../../templateEditor.theme'
import { toDisplaySize } from '../../templateEditor.utils'
import elementStyles from './templateEditorElementViews.jcss'

type Props = { element: ShapeElement; scale: number; theme: EditorTheme }

const shapeRadius = (element: ShapeElement, scale: number) => {
    if (element.shapeKind === 'ellipse') {
        return '50%'
    }
    if (element.shapeKind === 'rounded' || element.radius) {
        return toDisplaySize(element.radius || 24, scale)
    }
    return 0
}

export const TemplateEditorShapeView: FC<Props> = ({ element, scale, theme }) => {
    const fill = element.fill || theme.demoFill

    if (element.shapeKind === 'line') {
        const ends = element.lineEnds ?? { x1: 0, y1: element.h / 2, x2: element.w, y2: element.h / 2 }
        const stroke = Math.max(2, Math.min(element.w, element.h, 4) || 4)
        return (
            <svg
                className={elementStyles.shape}
                viewBox={`0 0 ${Math.max(element.w, 1)} ${Math.max(element.h, 1)}`}
                preserveAspectRatio="none"
                style={{ overflow: 'visible' }}
            >
                <line
                    x1={ends.x1}
                    y1={ends.y1}
                    x2={ends.x2}
                    y2={ends.y2}
                    stroke={fill}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                />
            </svg>
        )
    }

    return (
        <div
            className={elementStyles.shape}
            style={{
                background: fill,
                borderRadius: shapeRadius(element, scale),
            }}
        />
    )
}
